export const FacebookCrmTypeDecorator = {
  url() {
    return `signup-hubspot/fb-crm`;
  },
  query() {
    return {};
  }
};